export const GET_23LIMITS_START='GET_23LIMITS_START';
export const GET_23LIMITS_SUCCESS='GET_23LIMITS_SUCCESS';
export const GET_23LIMITS_FAIL='GET_23LIMITS_FAIL';

export const UPDATE_23LIMIT_START='UPDATE_23LIMIT_START';
export const UPDATE_23LIMIT_SUCCESS='UPDATE_23LIMIT_SUCCESS';
export const UPDATE_23LIMIT_FAIL='UPDATE_23LIMIT_FAIL';

export const TOGGLE_23LIMIT_UPDATE='TOGGLE_23LIMIT_UPDATE';
